import {Component} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {RgpdNotifComponent} from './rgpd-notif/rgpd-notif.component';
import {ProfileService} from '../services/profile.service';
import {Router, RouterOutlet} from '@angular/router';
import {KeycloakService} from 'keycloak-angular';
import {RolesService} from "../services/roles.service";

import {TopbarComponent} from "../components/user/topbar/topbar.component";
import {FooterComponent} from "../components/common/footer/footer.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {BackToTopComponent} from "../components/common/back-to-top/back-to-top.component";
import { SkiplinksComponent } from '../components/common/skiplinks/skiplinks.component';

@Component({
    selector: 'app-user',
    imports: [
    TopbarComponent,
    RouterOutlet,
    FooterComponent,
    FaIconComponent,
    BackToTopComponent,
    SkiplinksComponent
],
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.css']
})
export class UserComponent {

  disabledAccount = false;

  constructor(private profileService: ProfileService,
              private toastr: ToastrService,
              protected router: Router,
              private rolesService: RolesService,
              private keycloakService: KeycloakService) {
    this.profileService.getProfile().subscribe(p => {
      // If we are "collaborateur", we have an empty profile but we do not care !
      if (this.rolesService.isCollaborateur()) {
        return;
      }
      if (p.account == null) {
        this.disabledAccount = true;
      } else if (!p.rgpd.accepted && !this.profileService.RGPDPopupOpened) {
        this.profileService.RGPDPopupOpened = true;
        this.toastr.info('', '', {
          toastComponent: RgpdNotifComponent,
          disableTimeOut: true,
          closeButton: false,
          enableHtml: true,
          tapToDismiss: false,
          positionClass: 'toast-rgpd'
        });
      }
    });
  }

  logout(): void {
    this.keycloakService.logout();
  }
}
